
import api from '@/api/proxyWeb/devis'

export default {

    getAll({ commit, rootState }) {

        commit('setDevis', null)

        let params = {
            client_id: rootState.clients.currentId,
            site_id: rootState.sites.currentId
        }

        let promise = new Promise(resolve => {
        
            Promise.all([
                api.count(params),
                api.list(params)
            ])
            .then( ([ count, devis ]) => {
                commit('setCount', count)
                commit('setDevis', devis)
                resolve(devis)
            })
        });

        return promise;
    }, 

    getNext({ commit, state, rootState }) {

        let params = {
            client_id: rootState.clients.currentId,
            site_id: rootState.sites.currentId,
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(devis => {
                commit('setNextDevis', devis)
            })
    }    
}